import { Col } from 'reactstrap';
import React, { Fragment } from 'react';
import InputComponent from '../InputComponent';
import { useEffect } from 'react';
const RadioGroup = (props) => {
    const onRadioChanged = (e) => {
        const newValue = parseInt(e.target.value);
        const updatedValue = props.value === newValue ? null : newValue;
        props.changed(updatedValue, e);
    };

    return (
        <Fragment>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0">
                <div
                    className={`form-check custom-form-selection d-flex align-items-center ${
                        props.value === props?.answerInternalIdentifier ? 'custom-form-selection-active' : ''
                    }`}
                >
                    <InputComponent
                        className={` ${props?.displayPosition === 'right' ? 'form-check-left' : ''} form-check-input ${
                            props?.answerInternalIdentifier === props.value && 'form-check-input-radio-checked'
                        }`}
                        type="radio"
                        name={props?.answerInternalIdentifier}
                        id={props?.answerInternalIdentifier}
                        value={props?.answerInternalIdentifier}
                        // onChange={onRadioChanged}
                        disabled={props.disable}
                        checked={props?.answerInternalIdentifier === props.value}
                        // onBlur={props.handleOnBlur}
                        onClick={onRadioChanged}
                    />
                    <label
                        className={`${
                            props?.displayPosition === 'right' ? 'form-check-left-label' : 'ms-2'
                        } form-check-label d-flex align-items-center ${
                            props.value === props?.answerInternalIdentifier ? 'label-active' : ''
                        }`}
                        htmlFor={props?.answerInternalIdentifier}
                    >
                        {props.answerText}
                    </label>
                </div>
            </Col>
        </Fragment>
    );
};

export default RadioGroup;
